import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import ConnectedAccountInputs from '../components/AccountInputs';
import Layout from '../components/Layout';
import withPackages from '../containers/withPackages';
import ResellerLayout from '../components/ResellerLayout';

import { COOKIES } from '../constants';
import { getCookie } from '../utils/cookieHelpers';
import { bucketUser } from '../experiments/index';
import { getCustomAttributes } from '../experiments/getCustomAttributes';
import { signupConfidenceExperiment } from '../experiments/signupConfidence/experiment';

export class Account extends React.Component {
  constructor() {
    super();
    const experimentToken = getCookie(COOKIES.EXPERIMENT_TOKEN);
    const cstmAttributes = getCustomAttributes(experimentToken);
    bucketUser(cstmAttributes, signupConfidenceExperiment);
  }

  componentDidMount() {
    this.props.getPackages();
  }

  render() {
    if (queryString.parse(this.props.location.search).gcp) {
      return <ResellerLayout location={this.props.location} />;
    }
    return (
      <Layout
        title="Let’s Get Started"
        subtitle="Review your plan and create an account."
      >
        <ConnectedAccountInputs />
      </Layout>
    );
  }
}

Account.propTypes = {
  getPackages: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default withPackages(Account);
